export function bulkReopenPrompt(count: number) {
	const noun = count === 1 ? "thread" : "threads"
	return {
		title: `Move ${count} ${noun} back to the inbox?`,
		description: `${count === 1 ? "It leaves" : "They leave"} Done and ${count === 1 ? "shows" : "show"} as open for the whole team.`,
		confirmText: "Move to Inbox",
	}
}
